/*eslint-disable */
"use strict";

var tracking = require("./home/tracking");
var zipAutoSuggest = require("./home/zipAutoSuggest");
require("./home/altSearch").init();
var experimentsTracking = require("./home/experimentsTracking");
require("../../../node_modules/showcar-carousel");

document.addEventListener("DOMContentLoaded", function() {
  //experimentsTracking should be set before publishing tracking info
  try {
    experimentsTracking.setUp();
  } catch (e) {
    console.log("experimentsTracking.setUp:" + e);
  }
  if (tracking !== undefined) {
    tracking.publishTrackingInfo();
  }
});

document.addEventListener("DOMContentLoaded", function() {
  if (zipAutoSuggest !== undefined) {
    zipAutoSuggest.init();
  }
});
